import { CartOrderSaved } from "./CartOrder";
import { License } from "./Company";
import { RouteType } from "./RouteType";

export interface Auth {
    user: User | undefined,
    setUser: (user: User) => void;
    token: string | undefined,
    setToken: (token: string) => void;
    logout: () => void;
    userAuthorizedRoutes: RouteType[],
    setUserAuthorizedRoutes: React.Dispatch<React.SetStateAction<RouteType[]>>;
}

export interface User {
    pk: string,
    sk: string,
    email: string,
    attributes: UserAttributes,
    companyAttributes?: {
        dealerId: string,
        companyName: string
        logo?: string,
        active?: boolean,
        international?: boolean,
        licenses?: License[]
    }
}

export interface UserAttributes {
    type: RoleType;
    accountStatus: string,
    firstName: string,
    lastName: string,
    savedOrders?: CartOrderSaved[],
    viewedBulletins?: string[],
    phone?: string,
    tempPassword?: string,
    registerCode?: string,
    showTutorial?: boolean,
    passwordResetCode?: string,
    showInternationalOrderMessage?: boolean,
    leadsContact?: boolean,
}

export const RoleType = {
    Admin: 'admin',
    DealerAdmin: 'dealer-admin',
    DealerService: 'dealer-service',
    DealerSales: 'dealer-sales',
    DealerSupport: 'dealer-support'
} as const

export type RoleType = typeof RoleType[keyof typeof RoleType];

export type RoleTypeLabel = {
    value: RoleType;
    label: string;
    description: string
} 

export const RoleTypeList: RoleTypeLabel[] = [
    { value: RoleType.DealerAdmin, label: 'Dealer Admin', description: '[Dealer Admin] account permission has full Dealer Portal access.' },
    { value: RoleType.DealerService, label: 'Service & Parts', description: '[Service & Parts] account permission has access to warranty claims, tech support, dealer resources, and relevant information on the Dashboard.' },
    { value: RoleType.DealerSales, label: 'Sales & Service', description: '[Sales & Service] account permission has all access the [Admin] account has except edit user permissions, and viewing financial data.' },
    { value: RoleType.DealerSupport, label: 'Support', description: `['Support'] account permission has all access to account without order placement.` }
]

export const RoleTypeListAdmin: RoleTypeLabel[] = [
    { value: RoleType.Admin, label: 'MadJax Admin', description: '[MadJax Admin] admin account used only for internal MadJax employees.' },
    { value: RoleType.DealerAdmin, label: 'Dealer Admin', description: '[Dealer Admin] account permission has full Dealer Portal access.' },
    { value: RoleType.DealerService, label: 'Service & Parts', description: '[Service & Parts] account permission has access to warranty claims, tech support, dealer resources, and relevant information on the Dashboard.' },
    { value: RoleType.DealerSales, label: 'Sales & Service', description: '[Sales & Service] account permission has all access the [Admin] account has except edit user permissions, and viewing financial data.' },
    { value: RoleType.DealerSupport, label: 'Support', description: `['Support'] account permission has all access to account without order placement.` }
]